import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { breakpoint, colors, sizes } from 'variables';
import { rem } from 'modules/helpers/style';
import websiteSettings from 'modules/websiteSettings';
import type { FooterContactViewModel } from 'autogen/swagger/all';
import dynamic from 'helpers/dynamic';
import { Body } from 'components/generic/typography';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import LinkAction from 'components/shared/Routing/components/LinkAction/LinkAction';

const Phone = dynamic(() => import('icons/Phone.svg?react'));

// #region Styles
const StyledPhone = styled(Phone)`
    display: none;

    ${breakpoint.up(sizes.sm)} {
        display: flex;
        width: 100%;
        height: 100%;
        max-width: 48px;
        max-height: 48px;
        margin-right: ${Spacing16};
    }
`;

const ContactText = styled.div`
    display: flex;
    flex-direction: column;
    line-height: ${rem(20)};
`;

const ChatButton = styled.button`
    display: flex;
    padding: 0;
    font-weight: bold;
    color: ${colors.brand1};
    border: 0;
    background: none;
    text-decoration: underline;
    line-height: ${rem(20)};
`;

const ZendeskLink = styled(LinkAction)`
    display: flex;
    padding: 0;
    font-weight: bold;
    color: ${colors.brand1};
    border: 0;
    background: none;
    text-decoration: underline;
    line-height: ${rem(20)};
`;
// #endregion Styles

interface IProps {
    contact: FooterContactViewModel;
}

export default function ContactInfo(props: IProps): JSX.Element {
    const { contact } = props;
    const { title, phone, startChat, zendeskLink, zendeskLinkText } = contact;

    const [chatEnabled, setChatEnabled] = useState<boolean>(true);

    useEffect(() => {
        const { liveChat } = websiteSettings;
        const { isChatEnabled } = liveChat;
        if (isChatEnabled !== undefined) {
            setChatEnabled(isChatEnabled);
        }
    }, []);

    return (
        <>
            <StyledPhone aria-hidden />
            <ContactText>
                <Body as="span" size="M" strong>
                    {title}
                </Body>
                <Body as="span" size="M">
                    {phone}
                </Body>
                {chatEnabled && <ChatButton className="js-hook-OpenCustomerServiceChat">{startChat}</ChatButton>}
                {zendeskLink && <ZendeskLink action={zendeskLink}>{zendeskLinkText}</ZendeskLink>}
            </ContactText>
        </>
    );
}
